<template>
    <div>
        <div v-if="isMenuPath(route.path)" class="sticky top-16 z-40 h-16 w-full bg-white shadow-sm transition-opacity lg:top-24">
            <client-only>
                <transition name="fade-down" mode="out-in">
                    <CategorySwiper v-if="Object.keys(shop().currentMenu).length" :key="checkout().input.dispatchType" />
                </transition>
            </client-only>
        </div>
        <div class="mb-5 pt-16 md:mb-8 md:pt-16 lg:pt-24">
            <transition name="fade-down" mode="out-in">
                <Headline
                    v-if="isCheckoutPath(route.path)"
                    :title="$t('checkoutPage.payment.toOrder')"
                />
            </transition>
        </div>
        <div id="shopContainer" class="container mx-auto flex flex-col gap-4 md:gap-8">
            <div class="relative flex flex-col gap-5 md:gap-12 lg:flex-row">
                <div
                    class="lg:w-8/12"
                    :class="{
                        'lg:w-8/12': webshopSettings().hasDispatchTypes,
                        'lg:w-full': !webshopSettings().hasDispatchTypes
                    }"
                >
                    <slot />
                </div>
                <CartContainer v-if="webshopSettings().hasDispatchTypes" />
            </div>
        </div>
        <client-only v-if="cartDebugMode">
            <CartDevInfo />
        </client-only>
    </div>
</template>

<script setup lang="ts">
    import CartContainer from '~/components/Cart/CartContainer.vue'
    import CartDevInfo from '~/components/Cart/CartDevInfo.vue'
    // TODO: would be better to use the ID for the navigation of the categories
    import CategorySwiper from '~/components/Category/CategorySwiper.vue'
    import Headline from '~/components/Headline.vue'
    import { checkout } from '~/store/checkout'
    import { shop } from '~/store/shop'
    import { webshopSettings } from '~/store/webshopSettings'
    import { isCheckoutPath, isMenuPath } from '~/utils/path-utils'
    const { public: { cartDebugMode } } = useRuntimeConfig()
    const route = useRoute()
</script>
